import React, { FunctionComponent } from 'react';
import { ProgressBarFlow } from 'scenes/common/types';
import styled from 'styled-components';

import ProgressFlowBarItem from './ProgressFlowBarItem';

const ProgressWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const ProgressFlowBar: FunctionComponent<{
  currentProgressBarFlow?: ProgressBarFlow;
}> = ({ currentProgressBarFlow }) => (
  <ProgressWrapper>
    {Object.values(ProgressBarFlow).map((flow: ProgressBarFlow, i: number) => {
      const currentFlowIndex = Object.values(ProgressBarFlow).findIndex(
        (item) => item === currentProgressBarFlow
      );
      return (
        <ProgressFlowBarItem
          key={flow}
          flowNumber={i + 1}
          flowName={flow}
          isCurrentFlow={currentProgressBarFlow === flow}
          isFlowComplete={i < currentFlowIndex}
        />
      );
    })}
  </ProgressWrapper>
);

export default ProgressFlowBar;
